import React from 'react'
import { SearchLg } from '@untitled-ui/icons-react'
import MyBgPatternDecorativeCircle from '../Decorative/MyBgPatternDecorativeCircle'

// Empty-state graphic for MyDataTable. The table renders this whenever a LOADED
// list has zero rows — a typed search that matched nothing, a filter/tab with no
// results, or a plain-empty list. The old "waiting for a search" gate was removed
// (see MyDataTable), so an empty table is never waiting for the user to search —
// it simply has no data. The headline is therefore always "Data not found";
// `isSearch` only tailors the sub-text (a search that returned nothing vs a list
// that has no data yet).
function MyDataNotFound({ isSearch }) {
  return (
    <div className="flex w-full max-w-[375px] flex-col items-center gap-2.5">
      <div>
        <MyBgPatternDecorativeCircle>
          <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-gray-light/200 text-gray-light/700">
            <SearchLg size={28} stroke="currentColor" />
          </div>
        </MyBgPatternDecorativeCircle>
      </div>
      <div className="z-20 flex flex-col gap-2 text-center">
        <p className="text-xl-semibold text-gray-light/900">Data not found</p>
        <p className="text-md-regular text-gray-light/600">
          {isSearch
            ? 'Your search did not match any data. Please try again.'
            : 'There is no data to display yet.'}
        </p>
      </div>
    </div>
  )
}

export default MyDataNotFound
